import { Outlet } from 'react-router-dom'
import React, { useEffect } from 'react'
import './App.scss'

function App() {
    useEffect(() => {
        window.addEventListener('resise', () => {
            window.scrollTo(0, 0)
        })
    })
    return (
        <div className="App">
            <Outlet />
        </div>
    )
}

export default App
